import { EmailMarketingProvider } from "@sp-crm/core";

export interface ProviderInfo {
    provider: EmailMarketingProvider;
    displayName: string;
    redirectPath: string;
    audienceKey?: string;
}

const PROVIDER_CONFIGS: Record<EmailMarketingProvider, ProviderInfo> = {
    [EmailMarketingProvider.Mailchimp]: {
        provider: EmailMarketingProvider.Mailchimp,
        displayName: "Mailchimp",
        redirectPath: "/settings/integrations/mailchimp",
        audienceKey: "mailchimp",
    },
    [EmailMarketingProvider.ConstantContact]: {
        provider: EmailMarketingProvider.ConstantContact,
        displayName: "Constant Contact",
        redirectPath: "/settings/integrations/constant-contact",
        audienceKey: "constantContact",
    },
};

export function getProviderFromPath(pathname: string): ProviderInfo {
    if (pathname.includes("/mailchimp/")) {
        return PROVIDER_CONFIGS[EmailMarketingProvider.Mailchimp];
    } else if (pathname.includes("/constant-contact/")) {
        return PROVIDER_CONFIGS[EmailMarketingProvider.ConstantContact];
    }

    return PROVIDER_CONFIGS[EmailMarketingProvider.Mailchimp];
}

export function getProviderConfig(provider: EmailMarketingProvider): ProviderInfo {
    const config = PROVIDER_CONFIGS[provider];
    if (!config) {
        return PROVIDER_CONFIGS[EmailMarketingProvider.Mailchimp];
    }
    return config;
}
